import { signInWithEmailAndPassword } from "firebase/auth";
import auth from "./firebase";
import { TOKEN_REFRESH_INTERVAL } from "../constant";

let login = async (email, password) => {


  try {
    let userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    return userCredential.user;
  } catch (error) {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.log("Error in login");
    localStorage.setItem('avEcoAccessToken','')
  }
};

export { login };
